export function isValidHexColor(color: string): boolean {
    const regex = /^#([0-9a-f]{3}){1,2}$/i;
    return regex.test(color);
}
